import dayjs from "dayjs";

const PIVOT_YEAR = 30

export const completeDateDigitsPassengers = (date:string) =>{
    let dateAux = date ? dayjs(date) : null
        if (dateAux && !dateAux.isValid()) {
          const daysToFix = date.split('-')[0];
          const monthsToFix = date.split('-')[1];
          const yearToFix = date.split('-')[2];
          if(yearToFix){
            const yearFixed = Number(yearToFix) > PIVOT_YEAR ? '19' + yearToFix : '20' + yearToFix
            dateAux = dayjs(yearFixed + '-' + monthsToFix + '-' + daysToFix)
          }
        }
        return dateAux
}